export class Master {

  public static ParaBirimi = 'ParaBirimi';
  public static OdemeYontemi = 'OdemeYontemi';
  public static TeslimYeri = 'TeslimYeri';
  public static TeslimSekli = 'TeslimSekli';
  public static Sehir = 'Sehir';
  public static SarfYeri = 'SarfYeri';
  public static FaturaTipi = 'FaturaTipi'
  public static Lokasyon = 'Lokasyon'
  public static UrunCinsi = 'UrunCinsi'
  public static AracTipi = 'AracTipi'

  id: number;
  tipi: string;
  kodu: string;
  aciklama: string;


  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }

}
